// @ts-nocheck
/* eslint-disable */
import SceneGeometry from "./geometry";
import SceneGeometrySmart from "./smart";
import SceneCoords from "~/scene/common/coords";

export default class SceneGeometrySmartMulti extends SceneGeometrySmart {
	_geometries: Array<SceneGeometry | SceneGeometrySmart>;

	constructor(scene, itemId, data, options) {
		super(scene, itemId);

		this._data = data;
		this._geometries = [];
		this._source = "";
		this._plainId = 0;
		this._disableClick = false;
		this._visible = true;

		this.setOptions(options);
		this._setFromData();
	}

	destroy() {
		while (this._geometries.length) {
			this._geometries.pop().destroy();
		}
	}

	// moje
	get featureInfo() {
		return {
			name: "SceneGeometrySmartMulti",
			type: "geometry"
		};
	}

	get visible() {
		return this._visible;
	}

	get isClickable() {
		return this._options && this._options.clickable;
	}

	getCreateData() {
		let rd = super.getCreateData();

		rd.data = this._data;
		rd.disabledClick = this._disableClick;

		return rd;
	}

	//eventy
	disableClick() {
		this._disableClick = true;

		this._onChange(this._scene.featureEvent("geometryMultiDisableClick", true, true), arguments);
	}

	// nevola prime eventy
	addGeometry(geometry) {
		this._geometries.push(geometry);
		this._countBBox();
	}

	getGeometries() {
		return this._geometries;
	}

	clear() {
		this._geometries.forEach(geometry => {
			geometry.clear();
		});
		this._countBBox();
	}

	setOwner(owner) {
		for (let i = 0; i < this._geometries.length; i++) { this._geometries[i].appended = !!owner; }

		super.setOwner(owner);
	}

	computeCenterZoom(usePadding) {
		let coords = [];

		let coordsArray = this._coords[0] instanceof SceneCoords ? [this._coords] : this._coords;

		for (let i = 0; i < coordsArray.length; i++) {
			let gc = coordsArray[i];

			for (let j=0;j<gc.length;j++) {
				let c = gc[j];

				if (!Array.isArray(c)) { c = [c]; }

				for (let k = 0; k < c.length; k++) {
					if (c[k] instanceof SceneCoords) { coords.push(c[k]); }
				}
			}
		}

		return this._scene.computeCenterZoom(coords, usePadding);
	}

	isArea() {
		for (let i = 0; i < this._geometries.length; i++) {
			if (this._geometries[i].type != this._scene.GEOMETRY.POLYGON) { return false; }
		}

		return true;
	}

	isPoint() {
		for (let i = 0; i < this._geometries.length; i++) {
			if (this._geometries[i].type != this._scene.GEOMETRY.CIRCLE) { return false; }
		}

		return true;
	}

	setSource(source) {
		this._source = source;
	}

	getSource() {
		return this._source;
	}

	setPlainId(plainId) {
		this._plainId = plainId;
	}

	getPlainId() {
		return this._plainId;
	}

	_setFromData() {
		let options = this._optionsFromData();
		let geom = this._data.geom;

		for (let key in options) {
			this._options[key] = options[key];
		}

		this._id = this._data.source + this._data.id;
		this._coords = [];
		this._visible = geom && geom.visible === false ? false : true;

		let minX = Infinity;
		let minY = Infinity;
		let maxX = -Infinity;
		let maxY = -Infinity;

		for (let i = 0; i < geom.data.length; i++) {
			const allCoords = this._scene.stringToCoords(geom.data[i]);

			for (const coordItem of allCoords) {
				minX = Math.min(coordItem.x, minX);
				minY = Math.min(coordItem.y, minY);
				maxX = Math.max(coordItem.x, maxX);
				maxY = Math.max(coordItem.y, maxY);
			}

			this._coords.push(allCoords);
		}

		if (minX !== Infinity) {
			this._bbox.min = this._scene.coordsFromWGS84(minX, minY);
			this._bbox.max = this._scene.coordsFromWGS84(maxX, maxY);
			this._bbox.empty = false;
		}

		this._typeFromData();

		this.setSource(this._data.source);
		this.setPlainId(this._data.id);

		this._prepareVisibleParts();
	}

	_optionsFromData() {
		let geom = this._data.geom;
		let result = {
			title: this._data.title
		};

		for (let p in geom.style) {
			if (p.match(/width|opacity/i)) {
				result[p] = parseFloat(geom.style[p]);
			}
			else {
				result[p] = geom.style[p];
			}
		}

		if (this._data.future) {
			result.color = "#aa00ff";
		}

		if (this._data.past) {
			result.color = "#990033";
		}

		return result;
	}

	_prepareVisibleParts() {
		super._prepareVisibleParts();
		if (this._options && this._options.clickable) {
			this._geometries.forEach(g => {
				g.setSource(this._source);
				g.setPlainId(this._plainId);
				if (this._source === "di" && (this._data.future || this._data.past)) {
					g.setClosureType(this._data.future ? "future" : "past");
				}
				g.setOptions({ clickable: true });
			});
		}
	}

	_typeFromData() {
		let geom = this._data.geom;

		switch (geom.type) {
			case "linestring":
			case "multilinestring":
				this._type = this._scene.GEOMETRY.POLYLINE;
			break;

			case "polygon":
			case "multipolygon":
				this._type = this._scene.GEOMETRY.POLYGON;
			break;

			case "point":
				this._type = this._scene.GEOMETRY.CIRCLE;
			break;

			case "path":
				this._type = this._scene.GEOMETRY.PATH;
			break;

			default:
				throw new Error("Unknown geometry '"+geom.type+"'");
			break;
		}
	}

	_countBBox() {
		let minX = Infinity;
		let minY = Infinity;
		let maxX = -Infinity;
		let maxY = -Infinity;

		this._bbox.min = null;
		this._bbox.max = null;
		this._bbox.empty = true;

		if (this._geometries && this._geometries.length) {
			for (const geom of this._geometries) {
				const bbox = geom.getBBoxWgs84();

				if (!bbox.empty) {
					minX = Math.min(bbox.min.x, minX);
					minY = Math.min(bbox.min.y, minY);
					maxX = Math.max(bbox.max.x, maxX);
					maxY = Math.max(bbox.max.x, maxY);
				}
			}
		}

		if (minX !== Infinity) {
			this._bbox.min = this._scene.coordsFromWGS84(minX, minY);
			this._bbox.max = this._scene.coordsFromWGS84(maxX, maxY);
			this._bbox.empty = false;
		}
	}
}
